// extracted by mini-css-extract-plugin
export default {"root":"WBtq5n"};